// input Box 3자리씩 콤마
export function comma(str) {
    str = String(str);

    if (Number(str) >= 0) {
        return str.replace(/[^0-9]/g,'').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
        return str = chgMinusFormat(str);
    }
}

export function unComma(str) {
    str = String(str);
    return Number(str.replace(/[^\d]+/g, ''));
}

function chgMinusFormat(str){
    var idx = str.indexOf('-');
    if(idx === 0){
    var tmpStr = str.substr(idx+1);
       //뒤에 마이너스가 또 있는지 확인
       if(tmpStr.indexOf('-')>=0){
             tmpStr = tmpStr.replace('-','');
          str = str.substr(0,idx+1) + tmpStr;  
       }
    } else if(idx>0){
          str = str.replace('-','');
    } else if(idx<0){
          return str;
    }
       return str;
  }

// 숫자 체크 정규식
export function isOnlyNumber(asValue) {
    const regExp = /[^0-9.]/g;
    return regExp.test(asValue); // 형식에 맞는 경우 true 리턴
}

//htmlUrlEncode
export function htmlUrlEncode(str) {
    if (str === "") return "";
  
    return str
      .replace(new RegExp("&", 'g'), "&amp;")
      .replace(new RegExp("<", 'g'), "&lt;")
      .replace(new RegExp(">", 'g'), "&gt;")
      .replace(new RegExp('"', 'g'), "&quot;")
      .replace(new RegExp("'", 'g'), "&#039;")
      .replace(new RegExp("'", 'g'), "&#39;")
      .replace(new RegExp("\r\n", 'g'), " ")
      .replace(new RegExp("\n", 'g'), " ");
  }